import React from 'react'
import Contact from '../components/Ownerinfo'
import Header from '../components/headerComp'
import Menu from '../components/menuComp'
import Footer from '../components/footerComp'

const ContactPage = () => {
  return (
    <div>
        < Header />
        < Menu />
        < Contact /> 
        < Footer />
    </div>
  )
}

export default ContactPage